import React from "react";
import { secciones } from "../../../datos";

const serviceIcons = [
  // Distribución
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l1 1h8l1-1zM13 6h4l3 5v4h-7V6z" />
  </svg>,
  // Almacenamiento
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
  </svg>,
  // Comercialización
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>,
  // Logística
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
  </svg>,
];

const cardColors = ["#151C84", "#C81416", "#0d125c", "#151C84"];

export function Servicios() {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#151C84]/3 rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#C81416]/4 rounded-full -translate-x-1/3 translate-y-1/3 blur-3xl pointer-events-none" />

      {secciones.map((datos, index) => (
        <div className="container mx-auto px-4 relative z-10" key={index}>
          {/* Header */}
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#151C84]/10 text-[#151C84] text-sm font-bold rounded-full mb-6 border border-[#151C84]/15">
              <span className="w-2 h-2 rounded-full bg-[#C81416]" />
              Nuestros Servicios
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-[#151C84] mb-4"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {datos.servicios[0].subtitle}
            </h2>
            <div className="flex items-center justify-center gap-2 mt-4">
              <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
              <div className="h-1.5 w-1.5 rounded-full bg-[#C81416]" />
              <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
            </div>
          </div>

          {/* Service cards grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {(datos.servicios[0].list || []).map((servicio, i) => (
              <div
                key={i}
                className="group relative bg-white rounded-2xl p-7 border border-gray-100 shadow-[0_2px_16px_rgba(21,28,132,0.06)] hover:shadow-[0_8px_40px_rgba(21,28,132,0.16)] transition-all duration-400 hover:-translate-y-3 overflow-hidden"
                data-aos="fade-up"
                data-aos-delay={i * 80}
              >
                {/* Top color bar */}
                <div
                  className="absolute top-0 left-0 right-0 h-1 transition-all duration-300 group-hover:h-1.5"
                  style={{ background: cardColors[i % cardColors.length] }}
                />

                {/* Icon */}
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 text-white transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3"
                  style={{ background: cardColors[i % cardColors.length] }}
                >
                  {serviceIcons[i % serviceIcons.length]}
                </div>

                <h3 className="text-lg font-bold text-[#151C84] mb-3">
                  {servicio.title || servicio.nombre || `Servicio ${i + 1}`}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {servicio.description || servicio.descripcion || ""}
                </p>

                {/* Bottom accent */}
                <div
                  className="mt-6 h-0.5 w-8 rounded-full group-hover:w-full transition-all duration-500"
                  style={{ background: cardColors[i % cardColors.length] }}
                />
              </div>
            ))}

            {/* Fallback si no hay lista — mostrar 3 cards genéricas */}
            {(!datos.servicios[0].list || datos.servicios[0].list.length === 0) && [
              { title: "Distribución Nacional", desc: "Cobertura en Santo Domingo, Norte y Sur del país con flota propia." },
              { title: "Almacenamiento", desc: "Gestión eficiente de inventario con tecnología de punta." },
              { title: "Comercialización", desc: "Alianzas con marcas líderes para llevar productos a cada punto de venta." },
            ].map((card, i) => (
              <div
                key={`fallback-${i}`}
                className="group relative bg-white rounded-2xl p-7 border border-gray-100 shadow-[0_2px_16px_rgba(21,28,132,0.06)] hover:shadow-[0_8px_40px_rgba(21,28,132,0.16)] transition-all duration-400 hover:-translate-y-3 overflow-hidden"
                data-aos="fade-up"
                data-aos-delay={i * 80}
              >
                <div className="absolute top-0 left-0 right-0 h-1" style={{ background: cardColors[i % cardColors.length] }} />
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 text-white transition-transform duration-300 group-hover:scale-110"
                  style={{ background: cardColors[i % cardColors.length] }}
                >
                  {serviceIcons[i % serviceIcons.length]}
                </div>
                <h3 className="text-lg font-bold text-[#151C84] mb-3">{card.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{card.desc}</p>
                <div className="mt-6 h-0.5 w-8 rounded-full group-hover:w-full transition-all duration-500" style={{ background: cardColors[i % cardColors.length] }} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
